/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * IRR Allowlist configuration
 */
export interface IrrAllowlistConfig { 
    /**
     * AWS S3 File location
     */
    location?: string;
    /**
     * Last modified timestamp
     */
    lastModifiedTs?: string;
}

